import { Button, Card, CardContent, Typography } from "@mui/material";

export default function ToolCard({ tool, Icon }) {
  const handleDownload = async (name) => {
    const url = "https://rohan-tax-services.onrender.com/api/auth/download";
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          toolname: name,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Download initiated:", data);
    } catch (error) {
      console.error("Error during download:", error);
    }
  };

  return (
    <Card className="flex flex-col h-full shadow-md hover:shadow-xl !transition-all rounded-lg border !duration-300">
      {/* Card Header */}
      <CardContent className="flex flex-col items-center text-center p-6">
        {/* Icon Section */}
        <div className="w-14 h-14 bg-gray-100  rounded-lg flex items-center justify-center mb-4 ">
          <Icon className="w-7 h-7 text-[#151C62]" />
        </div>
        {/* Tool Name */}
        <Typography variant="h6" className="text-xl font-bold text-gray-900">
          {tool.name}
        </Typography>
        {/* Tool Description */}
        <Typography
          variant="body2"
          className="text-sm text-gray-600 text-justify"
        >
          {tool.description}
        </Typography>
      </CardContent>

      {/* Action Button */}
      <div className="flex justify-center items-center mt-auto p-4">
        <Button
          variant="contained"
          className="text-white"
          component="a"
          href={tool.filePath}
          onClick={() => {
            handleDownload(tool.name);
          }}
          target="_blank"
          download
          sx={{
            color: "white",
            bgcolor: "#151C62",
          }}
        >
          Download Excel
        </Button>
      </div>
    </Card>
  );
}
